import {Suspense} from "react";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {BulkImportForm} from "@/pages/checks/bulk-import/BulkImportForm.tsx";

const formId = "import-checks";

interface CheckImportModalProps {
  show: boolean;
  close: () => void;
  cancel: () => void;
}

export const ImportCheckModal = ({show, close, cancel}: CheckImportModalProps) => (
  <Suspense>
    <UpErrorBoundary>
      <FormModal title="Bulk Import Checks" onCancel={cancel} show={show} formId={formId} submitBtnText="Save">
        <BulkImportForm formId={formId} hide={close} />
      </FormModal>
    </UpErrorBoundary>
  </Suspense>
);
